require('./header.scss');
require('bootstrap-sass/assets/javascripts/bootstrap.js');

// @vendor
const { Provider } = require('react-redux');
const PropTypes = require('prop-types');
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const classNames = require('classnames');
const OKTopbar = require('ok-topbar');
const Immutable = require('immutable');
const PureRenderMixin = require('react-addons-pure-render-mixin');

// @core
const { cookiesDomain } = require('core/environmentConfig');
const { getLanguage } = require('core/i18n').i18n;
const { formatText, FormattedText } = require('core/i18n').i18n;
const { store } = require('store/configureStore');

// @utilities
const storage = require('utilities/storage');
const { logoutUser } = require('utilities/LogoutHelper');
const withContactCenterValidation = require('utilities/withContactCenterValidation');
const { filterPotentiallyXSS } = require('commonsUtilities/securityHelper');
const {
    filterUnreadNotifications,
    decorateNotification,
    filterValidNotificationsToDisplay
} = require("utilities/notificationHelper")

// @components
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @actions
const logoutActions = require('actions/logout');
const profileActions = require('actions/profile');
const topbarActions = require('actions/topbar');
const userNotificationsActions = require('actions/userNotifications');
const { getChoreDetail } = require('actions/openYoungCardChores');
const { getMoneyRequestDetails } = require('actions/openYoungCardMoneyRequest');
const { moneySavingsRequestDetails } = require('actions/openYoungCardSavings');

// @ hoc
const withFeatureToggling = require('hocs/withFeatureToggling/withFeatureToggling');

// @ constants
const { DEPOSITS_TOPBAR, REFERRALS, TAXATION, MIFID, NOTIFICATIONS_MANAGEMENT } = require('constants/flagBasedFeatures');
const { LOCAL_ENVIRONMENT, USER_NOTIFICATIONS_GET_MIN_SIZE } = require('constants/index');
import { WEALTH_CRYPTO } from 'constants/flagBasedMBFeatures';

const { subscribeNotifyAsisEvent } = require('@gruposantander/mb-ui-framework');
const { tokenRefreshOnMBCalls } = require("../../adapter/utils/tokenRefreshOnMBCalls");

const LANGUAGES = ['es', 'en', 'pt', 'nl', 'fr', 'de'];


class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            styles: {
                left: 0
            }
        };
        this.handleScroll = this.handleScroll.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }
 
    componentDidMount() {
      const {
        getTopbar,
        language,
        loggedIn,
        requestSetBrowsingLanguage,
        requestUserNotifications,
        setUnreadNotificationsCount,
      } = this.props;

      // Do not request notifications when is not logged
      if (loggedIn && !!storage.cookies.get('tokenCredential')) {
            requestUserNotifications({'size': USER_NOTIFICATIONS_GET_MIN_SIZE})
            setUnreadNotificationsCount()
      }

      getTopbar(language, () => {
        const lang = LANGUAGES.includes(language) ? language : 'es';
        if (!storage.localStorage.get('topbarRequests')) {
          storage.localStorage.set('topbarRequests', true)
          requestSetBrowsingLanguage(lang);
        }
      })

      __CONTACT_CENTER__ && this.hidePrivateBarAndMenuCC();
      window.addEventListener('scroll', this.handleScroll);

    this.unSubscribeNotifyAsisEvent = subscribeNotifyAsisEvent(mbUrl => {
      if (tokenRefreshOnMBCalls(mbUrl)) {
        this.props.handleKeepAlive();
      }
    });
    }

    componentDidUpdate() {
        const isClose = this.props.immBanner.get('isClose');

        if (isClose && document.querySelector('.openbank-topbar')) {
            document.querySelector('.openbank-topbar').style.top = 0;
        }
        __CONTACT_CENTER__ && this.hidePrivateBarAndMenuCC();
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
        this.unSubscribeNotifyAsisEvent?.();
    }

    buildProfileTopbarTooltip() {
        return (
            <Provider store={store}>
                <OKTooltip
                    content="profile-topbarTooltip"
                    fixed={true}
                    placement="top"
                    type="descriptive"
                    target={<div className="profile-topbar-tooltip__target"></div>}
                />
            </Provider>
        );
    }

    hidePrivateBarAndMenuCC = () => {
        const privateBar = document.querySelector('.private-menu');
        if (!!privateBar) {
            if (this.props.hidePrivateBarAndMenu) {
                Array.from(privateBar.querySelectorAll('li'))
                    .filter(li => li.firstElementChild && li.firstElementChild.id !== 'btnpréStamosEHipotecas')
                    .forEach(li => li.style.display = 'none');

                // Hide user profile options

                privateBar.classList.add('private-menu--rnc');
                const loansAndMortagesButtons = document.querySelector('#btnpréStamosEHipotecas');
                if (loansAndMortagesButtons) {
                    loansAndMortagesButtons.href = location.origin + '/myprofile/mortgage';
                    loansAndMortagesButtons.classList.add('is-selected');
                }

                // Hide user profile options
                document.querySelector('.openbank-topbar__actions__user .icon-dropdown-abrir').style.display = 'none';
                document.querySelector('.actions-user__options').style.display = 'none';

                // Hide notifications icon
                const notifications = document.querySelector('#openbank-topbar_notifications');
                if (notifications) {
                    notifications.style.display = 'none';
                }
            }
        }
    }

    buildTopbarProps = () => {
        const { immTopbar } = this.props;
        let topbarData = immTopbar.get('topbarData').toJS();
        if (!topbarData)
            return null

        if (!this.props.flagBasedMBFeatures.get(WEALTH_CRYPTO)) {
            if (topbarData.private_menu && Array.isArray(topbarData.private_menu.banking)) {
                topbarData.private_menu.banking.forEach(item => {
                    if (item.id === 'investments' && Array.isArray(item.below)) {
                        item.below.forEach(subItem => {
                            if (subItem.id === 'you invest' && Array.isArray(subItem.below)) {
                                subItem.below = subItem.below.filter(b => b.id !== 'crypto');
                            }
                        });
                    }
                });
            }
            if (topbarData.private_menu && Array.isArray(topbarData.private_menu.wealth)) {
                topbarData.private_menu.wealth.forEach(item => {
                    if (item.id === 'you invest' && Array.isArray(item.below)) {
                        item.below = item.below.filter(b => b.id !== 'crypto');
                    }
                });
            }
        }

        const {
            avatar,
            language,
            loggedIn,
            name,
            flagBasedFeatures,
            history,
            immProfile,
            hidePrivateBarAndMenu,
            notifications,
            notificationsCount,
            privateMenuType,
            requestUserNotifications,
            setUnreadNotificationsCount,
            setUserNotifications,
            getChoreDetail,
            getMoneyRequestDetails,
            moneySavingsRequestDetails,
            immCards,
            immGlobalPosition,
            showOpenMarkets,
            handleLogout
        } = this.props;

        const origin =
            window.location.origin ||
            window.location.protocol +
            '//' +
            window.location.hostname +
            (window.location.port ? ':' + window.location.port : '');

        const decorateNotificationFunc = (notification) =>
            decorateNotification(notification, immCards, flagBasedFeatures, getChoreDetail, getMoneyRequestDetails, moneySavingsRequestDetails, history)
        const isDatabankEnabled = flagBasedFeatures && flagBasedFeatures.get("databank-enabled");
        const decoratedNotifications = (notifications || new Immutable.List())
            .filter(filterValidNotificationsToDisplay)
            .map(decorateNotificationFunc)
            .toJS()
        const isCollectiveLandingEnabled = immProfile.get('isCollective') && flagBasedFeatures.get("collectivos-enabled");

        let collective = '';
        let collective_background_color = '';
        let collective_text_color = '';
        let collective_url = '#';

        if(!immGlobalPosition.getIn(['savings','allSavings']).size && !flagBasedFeatures.get(DEPOSITS_TOPBAR)) {
            topbarData = {
                ...topbarData,
                private_menu: {
                    ...topbarData.private_menu,
                    banking: [...topbarData.private_menu.banking.filter(menuItem => menuItem.id !== 'deposits')]
                }
            }
        }

        if (immProfile.get('isCollective')){
            const { collectives, collective_landings = {} } = topbarData.topbar;
            const collectiveType = immProfile.get('collectiveType');
            const audience = `Collective_${collectiveType.get('company')}-${collectiveType.get('code3')}-${collectiveType.get('code4')}`;

            if (Array.isArray(collectives)) {
                collectives.forEach( col => {
                    if (col.target_audience.indexOf(audience) > -1 ){
                        collective = col.title
                        collective_url = collective_landings[audience];
                        collective_background_color = col.bg_color;
                        collective_text_color = col.text_color
                    }
                })
            } else {
                collective = collectives.title
                collective_url = collective_landings[audience];
                collective_background_color = collectives.bg_color;
                collective_text_color = collectives.text_color
            }
        }


        if (showOpenMarkets && flagBasedFeatures.get("retail_loan_waffer")) {
            const openMarketItem = {
                "id":"markets",
                "title":formatText('profileNavBar-contract_retail_loan'),
                "url":"https://clientes.openbank.es/myprofile/loans-mortgages/contract-retail-loan",
                "rightIcon": "https://www.openbank.es/assets/static/images/retail/open_markets_icon.svg"
            }

            for(let element of topbarData.private_menu.wealth) {
                if (element.id === "personal banking") {
                    element.below = [
                        ...element.below,
                        openMarketItem
                    ]
                }
            }

            topbarData = {
                ...topbarData,
                private_menu: {
                    ...topbarData.private_menu,
                    banking: [...topbarData.private_menu.banking, openMarketItem]
                }
            }
        }

        let profileLinks = [
            { icon: 'icon-identidad', url: origin + '/myprofile/edit', label: formatText('profileNavBar-personalData') },
            { icon: 'icon-candado', url: origin + '/myprofile/keys', label: formatText('profileNavBar-passwords') },
            ...isDatabankEnabled ? [{ icon: 'icon-databank', url: origin + '/myprofile/databank', label: formatText('profileNavBar-databank') }] : [],
            { icon: 'icon-documento', url: origin + '/myprofile/documentation', label: formatText('profileNavBar-documentation') }
        ];

        if (!immProfile.get('isNerudaUser') && !immProfile.get('isAresUser')){
            profileLinks = [
                ...profileLinks,
                { icon: 'icon-preferencias', url: origin + '/myprofile/settings', label: formatText('profileNavBar-PGSettings') },
                ...flagBasedFeatures.get(TAXATION) ? { icon: 'icon-calcular', url: origin + '/myprofile/taxAndRents', label: formatText('profileNavBar-taxAndRents') } : [],
                //{ icon: 'icon-mas-productos', url: origin +'/descuentos-openbank', label: formatText('profileNavBar-OKDisconuntsPlan') },
                ...flagBasedFeatures.get(MIFID) ? { icon: 'icon-test-mifid', url: origin + '/myprofile/broker/consult-mifid/redirect', label: formatText('profileNavBar-mifidTest') } : [],
                ...flagBasedFeatures.get(REFERRALS) ? { icon: 'icon-invita-amigo', url: origin + '/myprofile/referrals', label: formatText('profileNavBar-inviteFriend') } : [],
                ...isCollectiveLandingEnabled ? { icon: 'icon-colectivos', url: origin + '/myprofile/collective-landing', label: formatText('profileNavBar-colectivos') } : []
            ];
        }
        var sources = {
            container: '#topbar',
            profileLinks: profileLinks,
            json: topbarData,
            side: loggedIn ? 'privada' : 'publica',
            lang: language,
            country: immProfile.get('originCountry'),
            authenticated: loggedIn,
            cookiesDomain: `.${cookiesDomain}`,
            showOnlyMortgages: immProfile.get('isNerudaUser') ? false : hidePrivateBarAndMenu,
            privateMenuType: storage.localStorage.get('privateMenuType') || privateMenuType,
            selectedPrivateLink: this.getSelectedPrivateLink(),
            showPGNerudaUser: immProfile.get('isNerudaUser'),
            showPGAresUser: immProfile.get('isAresUser'),
            translationForAresUser: {
                aresLoanTabName: <FormattedText value="breadcrumb-loans" />, // Added existing keys once we will get specific keys for ARES replace it
                aresAccountTabName: <FormattedText value="accounts-accounts" /> // Added existing keys once we will get specific keys for ARES replace it
            },
            translations: {
                dateTranslated: formatText('userNotifications-dateTranslated'),
                notificationsConfiguration: formatText('userNotifications-notificationSettings'),
                noMoreNotifications: formatText('userNotifications-noMoreNotifications'),
                goToMessagesLabel: formatText('userNotifications-seeMore'),
                myProfileTooltip: formatText('profile-topbarTooltip'),
                notificationsTooltip: formatText('userNotifications-notifications'),
                notificationsEmptyStateTitle: formatText('userNotifications-emptyTitle'),
                notificationsEmptyStateDescription: formatText('userNotifications-emptyContent'),
                newLabelForPrivate: formatText('navBar-new')
            },
            user: {
                avatar: filterPotentiallyXSS(avatar),
                name: filterPotentiallyXSS(name) || '-',
                notificationsCount,
                notifications: decoratedNotifications,
                collective,
                collective_background_color,
                collective_text_color,
                collective_url,
                showLinkNotificationsManagement: flagBasedFeatures.get(NOTIFICATIONS_MANAGEMENT)
            },
            onPrivateMenuSwitch: (type) => {
                storage.localStorage.set('privateMenuType', type);
            },
            onChangePreference: () => {
                const preference = storage.cookies.get('privateNavPreference');
                const preferenceValue = (preference === 'wealth') || false;

                // TODO: It should use document.querySelector because it are changing DOM instead of uses Virtual DOM.
                if (document.querySelector('.openbank-topbar')) {
                    document.querySelector('.openbank-topbar').style.top = 0;
                }
                // this.updateMenuMarker(this.props.pathname);

                this.setPreferenceValue(preferenceValue);
            },
            onLanguageSwitch: (evt, language) => {
                evt.preventDefault();
                evt.stopPropagation();
                const currentLanguage = __CONTACT_CENTER__ ? storage.cookies.get('language') : getLanguage();
                if (currentLanguage !== language) {
                    const { requestSetBrowsingLanguage } = this.props

                    requestSetBrowsingLanguage(language)
                }
                return true;
            },
            onLogout: () => {
                let attributes = {};

                if (window.__ENV__ !== LOCAL_ENVIRONMENT) {
                    attributes = { domain: cookiesDomain };
                }

                logoutUser(handleLogout);
                storage.cookies.remove('neruda', attributes);
                storage.cookies.remove('ares', attributes);
            },
            onPrivateLinkClick: function (url) {
                const regex = 'https?://[^/]+(.*)';
                const path = new RegExp(regex).exec(url);
                if (url.includes('myprofile')){
                    history.push(path ? path[1] : url);
                } else {
                    location.href = url;
                }
            },
            onNotificationsToggle: function(open) {
                if (open) {
                    if (notifications.size > 0) {
                        const unreadNotifications = notifications.filter(filterUnreadNotifications);
                        const unreadNotificationIds =  unreadNotifications.map(notification => notification.get('messageId'));
                        unreadNotificationIds.size && setUserNotifications(unreadNotificationIds, setUnreadNotificationsCount);
                    }
                    requestUserNotifications({'size': USER_NOTIFICATIONS_GET_MIN_SIZE});
                    setUnreadNotificationsCount();
                }
            }
        };

        if (immProfile.get('isCollective')){
            if(topbarData
                && topbarData.topbar
                && topbarData.topbar.collectives instanceof Array) {
                let collectiveType = immProfile.get('collectiveType');
                let audience = `Collective_${collectiveType.get('company')}-${collectiveType.get('code3')}-${collectiveType.get('code4')}`;
                topbarData.topbar.collectives.forEach(collective => {
                    if (collective.target_audience.indexOf(audience) > -1 ){
                        sources.user.collective = collective.title
                        sources.user.collective_url = topbarData.topbar.collective_landings[audience];
                        sources.user.collective_background_color = collective.bg_color;
                        sources.user.collective_text_color = collective.text_color
                    }
                });
            }
        }
        return sources;
    }

    setPreferenceValue(value) {
        const pereferenceElem = document.querySelector('.private-menu__switch-box');
        pereferenceElem && (pereferenceElem.checked = value);

        return true;
    }

    handleScroll() {
        const leftValue = '-' + document.body.scrollLeft + 'px';

        if (document.body.scrollLeft && leftValue !== this.state.styles.left) {
            this.setState({
                styles: {
                    left: leftValue
                }
            });
        }
    }

    getSelectedPrivateLink = () => {
        const { pathname, immProfile } = this.props;
        let selectedPrivateLink = pathname;
        const isAresUser = immProfile.get('isAresUser');

        if (pathname.includes('hire/card/') || pathname.includes('hire/pack/open-young')) {
            selectedPrivateLink = '/myprofile/cards';
        }

        else if (['/myprofile/purchase/deposit-eighteen-months', '/myprofile/purchase/depositnm', '/myprofile/purchase/deposit', '/myprofile/purchase/depositpayroll'].includes(pathname)) {
            selectedPrivateLink = '/myprofile/deposits'
        }

        else if (pathname.includes('/myprofile/purchase/')
            && ![
                '/myprofile/purchase/deposit-eighteen-months',
                '/myprofile/purchase/depositnm',
                '/myprofile/purchase/deposit',
                '/myprofile/purchase/deposittransfer',
                '/myprofile/purchase/depositrenewal',
                '/myprofile/purchase/depositexpired',
                '/myprofile/purchase/depositpayroll',
            ].includes(pathname)) {
                selectedPrivateLink = '/myprofile/accounts';
        }

        else if (pathname.includes('/robo') || pathname.includes('broker/watchlist')) {
            selectedPrivateLink = ['we invest for you', 'investments'];
        }

        else if (pathname.includes('/robo')) {
            selectedPrivateLink = ['we invest for you', 'investments'];
        }

        else if (pathname.includes('/myprofile/loans-mortgages/contract-retail-loan')) {
            selectedPrivateLink = ['markets'];
        }

        else if (pathname.includes('/myprofile/loans-mortgages') && isAresUser) {
            selectedPrivateLink = '/myprofile/loans-mortgages/aresusers';
        }
        // if (linkHref == "myprofile/broker/general" && pathname.includes('/myprofile/robo/')
        // ) {
        //     return true;
        // } else {
        //     return cleanLocation && linkHref && cleanLocation.includes(linkHref);
        // }

        return selectedPrivateLink;
    }

    render() {
        const { flagBasedFeatures, immTopbar, immGlobalPosition, immProfile, immFlagBasedFeatures } = this.props;

        if (
            !immGlobalPosition.get('hasBeenFetched')
            || !immProfile.get('hasBeenFetched')
            || immFlagBasedFeatures.get('isFetching')
        ) {
            return null
        }

        const headerClassName = classNames('header', {
            'header-dib': flagBasedFeatures && !flagBasedFeatures.get('robo-enabled'),
        });
        const topbarFetched = !immTopbar.get('isFetching') && !!immTopbar.get('success');
        const topbarProps = topbarFetched && this.buildTopbarProps()
        return (
            <nav className={headerClassName} id="topbar">
                {!!topbarProps && <OKTopbar {...topbarProps} />}
            </nav>
        );
    }
}

Header.propTypes = {
    avatar: PropTypes.string,
    immBanner: PropTypes.object,
    immProfile: PropTypes.object,
    language: PropTypes.string,
    loggedIn: PropTypes.bool,
    name: PropTypes.string,
    immCards: PropTypes.object.isRequired,
    pathname: PropTypes.string,
    hidePrivateBarAndMenu: PropTypes.bool,
    flagBasedFeatures: PropTypes.object,
    requestSetBrowsingLanguage: PropTypes.func,
    notifications: PropTypes.object,
    notificationsCount: PropTypes.number,
    privateMenuType: PropTypes.string,
    requestUserNotifications: PropTypes.func.isRequired,
    setUnreadNotificationsCount: PropTypes.func.isRequired,
    setUserNotifications: PropTypes.func.isRequired,
    getChoreDetail: PropTypes.func.isRequired,
    getMoneyRequestDetails: PropTypes.func.isRequired,
    moneySavingsRequestDetails: PropTypes.func.isRequired,
    immTopbar: PropTypes.object.isRequired,
    getTopbar: PropTypes.func.isRequired,
    showOpenMarkets: PropTypes.bool,
    history: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    handleLogout: PropTypes.func.isRequired,
    handleKeepAlive: PropTypes.func.isRequired,
};

Header.defaultProps = {
    hidePrivateBarAndMenu: false,
    showOpenMarkets: false
}

module.exports.constructor = Header;
const ConnectedHeader = connect(
    state => ({
        immCards: state.cards,
        immBanner: state.bannerUpdate,
        immProfile: state.profile,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immGlobalPosition: state.globalPosition,
        notifications: state.userNotifications.get('notifications'),
        notificationsCount: state.userNotifications.get('unreadCount'),
        privateMenuType: state.brokerSpinOffModal.privateMenuType,
        immTopbar: state.topbar,
        showOpenMarkets: state.segmentedLoanProducts.get('retailLoanSegmented')
    }), {
        requestUserNotifications: userNotificationsActions.requestUserNotifications,
        setUnreadNotificationsCount: userNotificationsActions.setUnreadNotificationsCount,
        setUserNotifications: userNotificationsActions.setUserNotifications,
        requestSetBrowsingLanguage: profileActions.requestSetBrowsingLanguage,
        getChoreDetail,
        getMoneyRequestDetails,
        moneySavingsRequestDetails,
        getTopbar: topbarActions.getTopbar,
        handleLogout: logoutActions.handleLogout,
        handleKeepAlive: logoutActions.keepAlive,
    }
)(withFeatureToggling(withRouter(Header)));

module.exports.Header = __CONTACT_CENTER__ ? withContactCenterValidation(ConnectedHeader) : ConnectedHeader
